<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="section form-column">
      <el-form
        label-width="50px"
        label-position="right"
        inline
        style="height:100%"
      >
        <el-form-item :label="$t('CargoMsg.Cargo_Search2')">
          <el-input v-model="typedText" :placeholder="$t('SystemMaintenance.PleaseCodeEnglishNameName')" style="width: 200px" @input="applyFilter" />
        </el-form-item>
        <el-form-item v-show="branchShow" :label="$t('SystemMaintenance.Branch')">
          <el-select v-model="officeId" @change="companyHandler">
            <el-option
              v-for="(item,index) in offices"
              :key="index"
              :label="item.chineseName"
              :value="item.officeId"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div slot="footer">
      <el-button type="primary" @click="enterHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button type="default" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getGridSelected } from '@/utils/agGrid'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'SubscribePortPushRuleCustomerDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    customers: { type: Array, required: true },
    branchId: { type: Number, default: -1 },
    branchShow: { type: Boolean, default: true },
    title: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      typedText: '',
      officeId: -1,
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abbreviation'),
          field: 'shortName',
          width: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseNamed'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
          field: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
          field: 'branchId',
          width: 100,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        }
      ],
      rowData: [],
      companies: [],
      offices: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.officeId = this.branchId
        if (this.branchId === 0) {
          this.officeId = -1
        }
        this.filterRowData()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.initializeHandler()
    this.addedToStageHandler()
  },
  methods: {
    initializeHandler() {
      this.offices = []
      const office = {}
      office.officeId = -1
      office.chineseName = this.$t('SystemMaintenance.All')
      this.offices.push(office)
      this.offices.push(...getCacheListByKey(basicCacheKeys.basic_data_Office_All))
    },
    addedToStageHandler() {
      const custMap = {}
      if (this.customers != null && this.customers.length > 0) {
        for (const c of this.customers) {
          custMap[c.cmpIdx] = c
        }
      }
      this.rowData = []
      const result = getCacheListByKey(basicCacheKeys.basic_data_Company)
      for (const cmp of result) {
        if (!custMap.hasOwnProperty(cmp.cmpIdx) && cmp.customer) {
          this.rowData.push(cmp)
          this.companies.push(cmp)
        }
      }
    },
    enterHandler() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectACustomer'))
        return
      }
      this.$emit('saveCallBack', selections)
      this.closeHandler()
    },
    closeHandler() {
      this.typedText = ''
      this.officeId = -1
      this.$emit('close')
    },
    applyFilter() {
      this.filterRowData()
    },
    companyHandler(val) {
      this.officeId = val
      this.filterRowData()
    },
    filterRowData() {
      this.rowData = this.companies.filter(row => this.filterCompany(row))
    },
    // 进行字符过滤
    filterCompany(company) {
      const filter = this.typedText
      const branchId = this.officeId
      if ((StrUtils.isEmpty(filter) || filter === ' ') && branchId === -1) { return true }
      if (!StrUtils.isEmpty(filter) && filter !== ' ') {
        if (company.cnShortName) {
          if (company.cnShortName.toLowerCase().indexOf(filter.toLowerCase()) >= 0 && (branchId === -1 ? true : company.branchId > -1 && company.branchId === branchId)) {
            return true
          }
        }

        if (company.shortName) {
          if (company.shortName.toLowerCase().indexOf(filter.toLowerCase()) >= 0 && (branchId === -1 ? true : company.branchId > -1 && company.branchId === branchId)) {
            return true
          }
        }

        if (company.chineseName) {
          if (company.chineseName.toLowerCase().indexOf(filter.toLowerCase()) >= 0 && (branchId === -1 ? true : company.branchId > -1 && company.branchId === branchId)) {
            return true
          }
        }

        if (company.englishName) {
          if (company.englishName.toLowerCase().indexOf(filter.toLowerCase()) >= 0 && (branchId === -1 ? true : company.branchId > -1 && company.branchId === branchId)) {
            return true
          }
        }
      } else {
        if (company.branchId > -1) {
          if (company.branchId === branchId) {
            return true
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>
